<template>
    <CardPage :section="6" :page="10">
        <p>
            Here’s a list of the strategies that you chose:
        </p>
        <v-sheet class="pa-3 mb-1" :elevation="1">
            <p class="font-weight-bold mb-0">{{ scenario1Text }}</p>
            <v-container fluid grid-list-xs>
                <v-layout row wrap justify-center>
                    <v-flex v-for="(strategy, index) in scenario1Strategies" :key="index" xs3 class="strategy">
                        <ResponsiveImage :src="strategy.image" layout="" flex="" :alt="strategy.title"></ResponsiveImage>
                    </v-flex>
                </v-layout>
            </v-container>
        </v-sheet>
        <v-sheet class="pa-3 mb-1" :elevation="1">
            <p class="font-weight-bold mb-0">{{ scenario2Text }}</p>
            <v-container fluid grid-list-xs>
                <v-layout row wrap justify-center>
                    <v-flex v-for="(strategy, index) in scenario2Strategies" :key="index" xs3 class="strategy">
                        <ResponsiveImage :src="strategy.image" layout="" flex="" :alt="strategy.title"></ResponsiveImage>
                    </v-flex>
                </v-layout>
            </v-container>
        </v-sheet>
        <v-sheet class="pa-3 mb-1" :elevation="1">
            <p class="font-weight-bold mb-0">{{ scenario3Text }}</p>
            <v-container fluid grid-list-xs>
                <v-layout row wrap justify-center>
                    <v-flex v-for="(strategy, index) in scenario3Strategies" :key="index" xs3 class="strategy">
                        <ResponsiveImage :src="strategy.image" layout="" flex="" :alt="strategy.title"></ResponsiveImage>
                    </v-flex>
                </v-layout>
            </v-container>
        </v-sheet>
        <p class="mt-3">Take a screen shot to use later.</p>
    </CardPage>
</template>

<script>
import { get } from 'vuex-pathify';
import { filter, values } from 'lodash';

export default {
    computed: {
        strategies: get('section6/strategies'),
        scenario1Text: get('section6/scenario1Text'),
        scenario2Text: get('section6/scenario2Text'),
        scenario3Text: get('section6/scenario3Text'),
        scenario1Strategies() {
            return filter(values(this.strategies), item => {
                return item.scenario1.selected;
            });
        },
        scenario2Strategies() {
            return filter(values(this.strategies), item => {
                return item.scenario2.selected;
            });
        },
        scenario3Strategies() {
            return filter(values(this.strategies), item => {
                return item.scenario3.selected;
            });
        }
    }
};
</script>

<style scoped>
.strategy {
    position: relative;
}
</style>
